"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _apolloClient = require("@/apollo/apolloClient");
var _clientQuery = require("@/apollo/queries/client-query");
var _DocumentCategory = require("@/lib/enum/DocumentCategory");
var state = {
  // ページング（ページトップNo）
  page_top: 0,
  // ページング（１ページあたりの表示サイズ）
  page_size: 50,
  // ページング（全一覧数）
  page_count: 0,
  // ページング（最終ページ）
  page_last: 0,
  client: {},
  clients: [],
  clients_contract: [],
  clients_invoice: [],
  clients_attendance: [],
  clients_labor_notice: [],
  searchClientWord: '',
  searchContractWord: '',
  searchContractAcceptance: '',
  searchInvoiceAcceptance: '',
  searchInvoiceWord: '',
  searchAttendancWord: '',
  searchLaborNoticeWord: ''
};
var mutations = {
  UPDATE_CLIENT: function UPDATE_CLIENT(state, client) {
    state.client = client.map(function (client_user) {
      return client_user;
    });
  },
  UPDATE_CLIENTS: function UPDATE_CLIENTS(state, clients) {
    state.clients = clients.map(function (client_user) {
      return client_user;
    });
  },
  SET_SEARCH_CLIENT_WORD: function SET_SEARCH_CLIENT_WORD(state, val) {
    state.searchClientWord = val;
  },
  UPDATE_CLIENTS_CONTRACT: function UPDATE_CLIENTS_CONTRACT(state, client_file_link) {
    state.clients_contract = client_file_link.map(function (client_file_link) {
      return client_file_link;
    });
  },
  UPDATE_CLIENTS_INVOICE: function UPDATE_CLIENTS_INVOICE(state, client_file_link) {
    state.clients_invoice = client_file_link.map(function (client_file_link) {
      return client_file_link;
    });
  },
  UPDATE_CLIENTS_ATTENDANCE: function UPDATE_CLIENTS_ATTENDANCE(state, client_file_link) {
    state.clients_attendance = client_file_link.map(function (client_file_link) {
      return client_file_link;
    });
  },
  UPDATE_CLIENTS_LABOR_NOTICE: function UPDATE_CLIENTS_LABOR_NOTICE(state, client_file_link) {
    state.clients_labor_notice = client_file_link.map(function (client_file_link) {
      return client_file_link;
    });
  },
  SET_SEARCH_CONTRACT_WORD: function SET_SEARCH_CONTRACT_WORD(state, val) {
    state.searchContractWord = val;
  },
  SET_SEARCH_ACCEPTANCE: function SET_SEARCH_ACCEPTANCE(state, val) {
    state.searchContractAcceptance = val;
  },
  SET_SEARCH_INVOICE_ACCEPTANCE: function SET_SEARCH_INVOICE_ACCEPTANCE(state, val) {
    state.searchInvoiceAcceptance = val;
  },
  SET_SEARCH_INVOICE_WORD: function SET_SEARCH_INVOICE_WORD(state, val) {
    state.searchInvoiceWord = val;
  },
  SET_SEARCH_ATTENDANCE_WORD: function SET_SEARCH_ATTENDANCE_WORD(state, val) {
    state.searchAttendancWord = val;
  },
  SET_SEARCH_LABOR_NOTICE_WORD: function SET_SEARCH_LABOR_NOTICE_WORD(state, val) {
    state.searchLaborNoticeWord = val;
  },
  setPageTop: function setPageTop(state, val) {
    state.page_top = val;
  },
  setPageSize: function setPageSize(state, val) {
    state.page_size = val;
  },
  setPageCount: function setPageCount(state, val) {
    state.page_count = val;
  }
};
var actions = {
  setPageTop: function () {
    var _setPageTop = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, page_top) {
      var commit;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            commit('setPageTop', page_top);
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function setPageTop(_x, _x2) {
      return _setPageTop.apply(this, arguments);
    }
    return setPageTop;
  }(),
  getPageTop: function () {
    var _getPageTop = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref2) {
      var commit;
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref2.commit;
            return _context2.abrupt("return", state.page_top);
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function getPageTop(_x3) {
      return _getPageTop.apply(this, arguments);
    }
    return getPageTop;
  }(),
  getPageLast: function () {
    var _getPageLast = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref3) {
      var commit;
      return regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            commit = _ref3.commit;
            return _context3.abrupt("return", state.page_last);
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function getPageLast(_x4) {
      return _getPageLast.apply(this, arguments);
    }
    return getPageLast;
  }(),
  setPageSize: function () {
    var _setPageSize = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref4, page_size) {
      var commit;
      return regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            commit = _ref4.commit;
            commit('setPageSize', page_size);
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    function setPageSize(_x5, _x6) {
      return _setPageSize.apply(this, arguments);
    }
    return setPageSize;
  }(),
  setPageCount: function () {
    var _setPageCount = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref5, page_count) {
      var commit;
      return regeneratorRuntime.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            commit = _ref5.commit;
            commit('setPageCount', page_count);
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    function setPageCount(_x7, _x8) {
      return _setPageCount.apply(this, arguments);
    }
    return setPageCount;
  }(),
  getPageCount: function () {
    var _getPageCount = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref6) {
      var commit;
      return regeneratorRuntime.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            commit = _ref6.commit;
            return _context6.abrupt("return", state.page_count);
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    function getPageCount(_x9) {
      return _getPageCount.apply(this, arguments);
    }
    return getPageCount;
  }(),
  fetchClient: function () {
    var _fetchClient = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(_ref7, login_id) {
      var commit, res;
      return regeneratorRuntime.wrap(function (_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            commit = _ref7.commit;
            _context7.next = 1;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.CLIENT_QUERY,
              variables: {
                login_id: login_id
              }
            });
          case 1:
            res = _context7.sent;
            commit('UPDATE_CLIENT', res.data.client_user);
          case 2:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    function fetchClient(_x0, _x1) {
      return _fetchClient.apply(this, arguments);
    }
    return fetchClient;
  }(),
  fetchClients: function () {
    var _fetchClients = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee8(_ref8) {
      var commit, _sWord, res;
      return regeneratorRuntime.wrap(function (_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            commit = _ref8.commit;
            if (state.searchClientWord) {
              _sWord = "%".concat(state.searchClientWord, "%");
            } else {
              _sWord = '%';
            }
            _context8.next = 1;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.CLIENTS_LIST_QUERY,
              variables: {
                search_word: _sWord
              }
            });
          case 1:
            res = _context8.sent;
            commit('UPDATE_CLIENTS', res.data.client_user);
          case 2:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    function fetchClients(_x10) {
      return _fetchClients.apply(this, arguments);
    }
    return fetchClients;
  }(),
  setClientWord: function () {
    var _setClientWord = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee9(_ref9, val) {
      var commit;
      return regeneratorRuntime.wrap(function (_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            commit = _ref9.commit;
            commit('SET_SEARCH_CLIENT_WORD', val);
          case 1:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    function setClientWord(_x11, _x12) {
      return _setClientWord.apply(this, arguments);
    }
    return setClientWord;
  }(),
  setContractWord: function () {
    var _setContractWord = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee0(_ref0, val) {
      var commit;
      return regeneratorRuntime.wrap(function (_context0) {
        while (1) switch (_context0.prev = _context0.next) {
          case 0:
            commit = _ref0.commit;
            commit('SET_SEARCH_CONTRACT_WORD', val);
          case 1:
          case "end":
            return _context0.stop();
        }
      }, _callee0);
    }));
    function setContractWord(_x13, _x14) {
      return _setContractWord.apply(this, arguments);
    }
    return setContractWord;
  }(),
  setInvoiceWord: function () {
    var _setInvoiceWord = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee1(_ref1, val) {
      var commit;
      return regeneratorRuntime.wrap(function (_context1) {
        while (1) switch (_context1.prev = _context1.next) {
          case 0:
            commit = _ref1.commit;
            commit('SET_SEARCH_INVOICE_WORD', val);
          case 1:
          case "end":
            return _context1.stop();
        }
      }, _callee1);
    }));
    function setInvoiceWord(_x15, _x16) {
      return _setInvoiceWord.apply(this, arguments);
    }
    return setInvoiceWord;
  }(),
  setLaborNoticeWord: function () {
    var _setLaborNoticeWord = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee10(_ref10, val) {
      var commit;
      return regeneratorRuntime.wrap(function (_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            commit = _ref10.commit;
            commit('SET_SEARCH_LABOR_NOTICE_WORD', val);
          case 1:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    function setLaborNoticeWord(_x17, _x18) {
      return _setLaborNoticeWord.apply(this, arguments);
    }
    return setLaborNoticeWord;
  }(),
  setSearchAcceptance: function () {
    var _setSearchAcceptance = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee11(_ref11, val) {
      var commit;
      return regeneratorRuntime.wrap(function (_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            commit = _ref11.commit;
            commit('SET_SEARCH_ACCEPTANCE', val);
          case 1:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
    function setSearchAcceptance(_x19, _x20) {
      return _setSearchAcceptance.apply(this, arguments);
    }
    return setSearchAcceptance;
  }(),
  setSearchInvoiceAcceptance: function () {
    var _setSearchInvoiceAcceptance = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee12(_ref12, val) {
      var commit;
      return regeneratorRuntime.wrap(function (_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            commit = _ref12.commit;
            commit('SET_SEARCH_INVOICE_ACCEPTANCE', val);
          case 1:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    }));
    function setSearchInvoiceAcceptance(_x21, _x22) {
      return _setSearchInvoiceAcceptance.apply(this, arguments);
    }
    return setSearchInvoiceAcceptance;
  }(),
  setSearchAttendance: function () {
    var _setSearchAttendance = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee13(_ref13, val) {
      var commit;
      return regeneratorRuntime.wrap(function (_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            commit = _ref13.commit;
            commit('SET_SEARCH_ATTENDANCE_WORD', val);
          case 1:
          case "end":
            return _context13.stop();
        }
      }, _callee13);
    }));
    function setSearchAttendance(_x23, _x24) {
      return _setSearchAttendance.apply(this, arguments);
    }
    return setSearchAttendance;
  }(),
  fetchClientsContract: function () {
    var _fetchClientsContract = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee14(_ref14, id) {
      var commit, _sWord, _bAcceptance, cnt, res;
      return regeneratorRuntime.wrap(function (_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            commit = _ref14.commit;
            if (state.searchContractWord) {
              _sWord = "%".concat(state.searchContractWord, "%");
            } else {
              _sWord = '%';
            }
            if (state.searchContractAcceptance === true || state.searchContractAcceptance === false) {
              _bAcceptance = state.searchContractAcceptance;
            } else if (state.searchContractAcceptance === 99) {
              _bAcceptance = null;
            } else {
              _bAcceptance = null;
            }
            if (!(state.searchContractAcceptance === 99)) {
              _context14.next = 2;
              break;
            }
            _context14.next = 1;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.CLIENTS_CONTRACT_LIST_COUNT_EX,
              variables: {
                client_id: id,
                file_type: _DocumentCategory.DocumentCategory.ClientDocumentType.Contract.val,
                searchWord: _sWord,
                is_acceptance: false,
                is_date_of_acceptance_null: false,
                is_release: true
              }
            });
          case 1:
            cnt = _context14.sent;
            _context14.next = 6;
            break;
          case 2:
            if (!(state.searchContractAcceptance === false)) {
              _context14.next = 4;
              break;
            }
            _context14.next = 3;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.CLIENTS_CONTRACT_LIST_COUNT_EX,
              variables: {
                client_id: id,
                file_type: _DocumentCategory.DocumentCategory.ClientDocumentType.Contract.val,
                searchWord: _sWord,
                is_acceptance: false,
                is_date_of_acceptance_null: true,
                is_release: true
              }
            });
          case 3:
            cnt = _context14.sent;
            _context14.next = 6;
            break;
          case 4:
            _context14.next = 5;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.CLIENTS_CONTRACT_LIST_COUNT,
              variables: {
                client_id: id,
                file_type: _DocumentCategory.DocumentCategory.ClientDocumentType.Contract.val,
                searchWord: _sWord,
                is_acceptance: _bAcceptance,
                is_release: true
              }
            });
          case 5:
            cnt = _context14.sent;
          case 6:
            state.page_size = 50;
            state.page_count = cnt.data.client_file_link_aggregate.aggregate.count;
            state.page_last = cnt.data.client_file_link_aggregate.aggregate.count === 0 ? 0 : Math.ceil(cnt.data.client_file_link_aggregate.aggregate.count / state.page_size) - 1;
            if (!(state.searchContractAcceptance === 99)) {
              _context14.next = 8;
              break;
            }
            _context14.next = 7;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.CLIENTS_CONTRACT_LIST_QUERY_EX,
              variables: {
                client_id: id,
                file_type: _DocumentCategory.DocumentCategory.ClientDocumentType.Contract.val,
                searchWord: _sWord,
                is_acceptance: false,
                is_date_of_acceptance_null: false,
                is_release: true,
                page_top: state.page_top * state.page_size,
                page_size: state.page_size
              }
            });
          case 7:
            res = _context14.sent;
            _context14.next = 12;
            break;
          case 8:
            if (!(state.searchContractAcceptance === false)) {
              _context14.next = 10;
              break;
            }
            _context14.next = 9;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.CLIENTS_CONTRACT_LIST_QUERY_EX,
              variables: {
                client_id: id,
                file_type: _DocumentCategory.DocumentCategory.ClientDocumentType.Contract.val,
                searchWord: _sWord,
                is_acceptance: false,
                is_date_of_acceptance_null: true,
                is_release: true,
                page_top: state.page_top * state.page_size,
                page_size: state.page_size
              }
            });
          case 9:
            res = _context14.sent;
            _context14.next = 12;
            break;
          case 10:
            _context14.next = 11;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.CLIENTS_CONTRACT_LIST_QUERY,
              variables: {
                client_id: id,
                file_type: _DocumentCategory.DocumentCategory.ClientDocumentType.Contract.val,
                searchWord: _sWord,
                is_acceptance: _bAcceptance,
                is_release: true,
                page_top: state.page_top * state.page_size,
                page_size: state.page_size
              }
            });
          case 11:
            res = _context14.sent;
          case 12:
            commit('UPDATE_CLIENTS_CONTRACT', res.data.client_file_link);
          case 13:
          case "end":
            return _context14.stop();
        }
      }, _callee14);
    }));
    function fetchClientsContract(_x25, _x26) {
      return _fetchClientsContract.apply(this, arguments);
    }
    return fetchClientsContract;
  }(),
  fetchClientsInvoice: function () {
    var _fetchClientsInvoice = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee15(_ref15, id) {
      var commit, _sWord, _bAcceptance, cnt, res;
      return regeneratorRuntime.wrap(function (_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            commit = _ref15.commit;
            if (state.searchInvoiceWord) {
              _sWord = "%".concat(state.searchInvoiceWord, "%");
            } else {
              _sWord = '%';
            }
            if (state.searchInvoiceAcceptance === true || state.searchInvoiceAcceptance === false) {
              _bAcceptance = state.searchInvoiceAcceptance;
            } else {
              _bAcceptance = null;
            }
            if (state.searchInvoiceAcceptance === true || state.searchInvoiceAcceptance === false) {
              _bAcceptance = state.searchInvoiceAcceptance;
            } else if (state.searchInvoiceAcceptance === 99) {
              _bAcceptance = null;
            } else {
              _bAcceptance = null;
            }
            if (!(state.searchInvoiceAcceptance === 99)) {
              _context15.next = 2;
              break;
            }
            _context15.next = 1;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.CLIENTS_CONTRACT_LIST_COUNT_EX,
              variables: {
                client_id: id,
                file_type: _DocumentCategory.DocumentCategory.ClientDocumentType.ConfirmationInvoice.val,
                searchWord: _sWord,
                is_acceptance: false,
                is_date_of_acceptance_null: false,
                is_release: true
              }
            });
          case 1:
            cnt = _context15.sent;
            _context15.next = 6;
            break;
          case 2:
            if (!(state.searchInvoiceAcceptance === false)) {
              _context15.next = 4;
              break;
            }
            _context15.next = 3;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.CLIENTS_CONTRACT_LIST_COUNT_EX,
              variables: {
                client_id: id,
                file_type: _DocumentCategory.DocumentCategory.ClientDocumentType.ConfirmationInvoice.val,
                searchWord: _sWord,
                is_acceptance: false,
                is_date_of_acceptance_null: true,
                is_release: true
              }
            });
          case 3:
            cnt = _context15.sent;
            _context15.next = 6;
            break;
          case 4:
            _context15.next = 5;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.CLIENTS_CONTRACT_LIST_COUNT,
              variables: {
                client_id: id,
                file_type: _DocumentCategory.DocumentCategory.ClientDocumentType.ConfirmationInvoice.val,
                searchWord: _sWord,
                is_acceptance: _bAcceptance,
                is_release: true
              }
            });
          case 5:
            cnt = _context15.sent;
          case 6:
            state.page_size = 50;
            state.page_count = cnt.data.client_file_link_aggregate.aggregate.count;
            state.page_last = cnt.data.client_file_link_aggregate.aggregate.count === 0 ? 0 : Math.ceil(cnt.data.client_file_link_aggregate.aggregate.count / state.page_size) - 1;
            if (!(state.searchInvoiceAcceptance === 99)) {
              _context15.next = 8;
              break;
            }
            _context15.next = 7;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.CLIENTS_CONTRACT_LIST_QUERY_EX,
              variables: {
                client_id: id,
                file_type: _DocumentCategory.DocumentCategory.ClientDocumentType.ConfirmationInvoice.val,
                searchWord: _sWord,
                is_acceptance: false,
                is_date_of_acceptance_null: false,
                is_release: true,
                page_top: state.page_top * state.page_size,
                page_size: state.page_size
              }
            });
          case 7:
            res = _context15.sent;
            _context15.next = 12;
            break;
          case 8:
            if (!(state.searchInvoiceAcceptance === false)) {
              _context15.next = 10;
              break;
            }
            _context15.next = 9;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.CLIENTS_CONTRACT_LIST_QUERY_EX,
              variables: {
                client_id: id,
                file_type: _DocumentCategory.DocumentCategory.ClientDocumentType.ConfirmationInvoice.val,
                searchWord: _sWord,
                is_acceptance: false,
                is_date_of_acceptance_null: true,
                is_release: true,
                page_top: state.page_top * state.page_size,
                page_size: state.page_size
              }
            });
          case 9:
            res = _context15.sent;
            _context15.next = 12;
            break;
          case 10:
            _context15.next = 11;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.CLIENTS_CONTRACT_LIST_QUERY,
              variables: {
                client_id: id,
                file_type: _DocumentCategory.DocumentCategory.ClientDocumentType.ConfirmationInvoice.val,
                searchWord: _sWord,
                is_acceptance: _bAcceptance,
                is_release: true,
                page_top: state.page_top * state.page_size,
                page_size: state.page_size
              }
            });
          case 11:
            res = _context15.sent;
          case 12:
            commit('UPDATE_CLIENTS_INVOICE', res.data.client_file_link);
          case 13:
          case "end":
            return _context15.stop();
        }
      }, _callee15);
    }));
    function fetchClientsInvoice(_x27, _x28) {
      return _fetchClientsInvoice.apply(this, arguments);
    }
    return fetchClientsInvoice;
  }(),
  fetchClientsAttendance: function () {
    var _fetchClientsAttendance = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee16(_ref16, id) {
      var commit, _sWord, cnt, res;
      return regeneratorRuntime.wrap(function (_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            commit = _ref16.commit;
            if (state.searchAttendancWord) {
              _sWord = "%".concat(state.searchAttendancWord, "%");
            } else {
              _sWord = '%';
            }
            _context16.next = 1;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.CLIENTS_CONTRACT_LIST_COUNT,
              variables: {
                client_id: id,
                file_type: _DocumentCategory.DocumentCategory.ClientDocumentType.ConfirmationAttendance.val,
                searchWord: _sWord,
                is_acceptance: null,
                is_release: null
              }
            });
          case 1:
            cnt = _context16.sent;
            state.page_size = 50;
            state.page_count = cnt.data.client_file_link_aggregate.aggregate.count;
            state.page_last = cnt.data.client_file_link_aggregate.aggregate.count === 0 ? 0 : Math.ceil(cnt.data.client_file_link_aggregate.aggregate.count / state.page_size) - 1;
            _context16.next = 2;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.CLIENTS_ATTENDANCE_LIST_QUERY,
              variables: {
                client_id: id,
                file_type: _DocumentCategory.DocumentCategory.ClientDocumentType.ConfirmationAttendance.val,
                searchWord: _sWord,
                is_acceptance: null,
                is_release: null,
                page_top: state.page_top * state.page_size,
                page_size: state.page_size
              }
            });
          case 2:
            res = _context16.sent;
            commit('UPDATE_CLIENTS_ATTENDANCE', res.data.client_file_link);
          case 3:
          case "end":
            return _context16.stop();
        }
      }, _callee16);
    }));
    function fetchClientsAttendance(_x29, _x30) {
      return _fetchClientsAttendance.apply(this, arguments);
    }
    return fetchClientsAttendance;
  }(),
  fetchClientsLaborNotice: function () {
    var _fetchClientsLaborNotice = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee17(_ref17, id) {
      var commit, _sWord, cnt, res;
      return regeneratorRuntime.wrap(function (_context17) {
        while (1) switch (_context17.prev = _context17.next) {
          case 0:
            commit = _ref17.commit;
            if (state.searchLaborNoticeWord) {
              _sWord = "%".concat(state.searchLaborNoticeWord, "%");
            } else {
              _sWord = '%';
            }
            _context17.next = 1;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.CLIENTS_CONTRACT_LIST_COUNT,
              variables: {
                client_id: id,
                file_type: _DocumentCategory.DocumentCategory.ClientDocumentType.ConfirmationLaborNotice.val,
                searchWord: _sWord,
                is_acceptance: null,
                is_release: true
              }
            });
          case 1:
            cnt = _context17.sent;
            state.page_size = 50;
            state.page_count = cnt.data.client_file_link_aggregate.aggregate.count;
            state.page_last = cnt.data.client_file_link_aggregate.aggregate.count === 0 ? 0 : Math.ceil(cnt.data.client_file_link_aggregate.aggregate.count / state.page_size) - 1;
            _context17.next = 2;
            return _apolloClient.apolloClient.query({
              query: _clientQuery.CLIENTS_CONTRACT_LIST_QUERY,
              variables: {
                client_id: id,
                file_type: _DocumentCategory.DocumentCategory.ClientDocumentType.ConfirmationLaborNotice.val,
                searchWord: _sWord,
                is_acceptance: null,
                is_release: true,
                page_top: state.page_top * state.page_size,
                page_size: state.page_size
              }
            });
          case 2:
            res = _context17.sent;
            commit('UPDATE_CLIENTS_LABOR_NOTICE', res.data.client_file_link);
          case 3:
          case "end":
            return _context17.stop();
        }
      }, _callee17);
    }));
    function fetchClientsLaborNotice(_x31, _x32) {
      return _fetchClientsLaborNotice.apply(this, arguments);
    }
    return fetchClientsLaborNotice;
  }()
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};